import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

const UploadStatusModal = ({ 
  open, 
  onClose, 
  uploadStatus,
  onUpgrade
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {uploadStatus?.canUpload ? 'Upload Status' : 'Action Required'}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {uploadStatus?.message}
        </Typography>
      </DialogContent>
      <DialogActions>
        {!uploadStatus?.canUpload && (
          <Button 
            onClick={onUpgrade}
            color="primary"
            variant="contained"
          >
            Upgrade Plan
          </Button>
        )}
        <Button onClick={onClose}>
          {uploadStatus?.canUpload ? 'Continue' : 'Cancel'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadStatusModal;